export default __webpack_public_path__ + "static/media/screw1.b828ff18.png";